import { Controller } from "@hotwired/stimulus"

// Builds the docs "On this page" table of contents from the <h2> headings in the
// content column (Kramdown gives each heading an auto-generated id), then keeps
// the active link in sync with whichever section is currently in view. Hides
// itself when there are no headings. Reconnects cleanly across Turbo visits.
export default class extends Controller {
  static targets = ["list"]
  static values = { content: { type: String, default: ".content" } }

  connect() {
    const content = document.querySelector(this.contentValue)
    this.headings = content ? Array.from(content.querySelectorAll("h2[id]")) : []

    if (this.headings.length === 0) {
      this.element.hidden = true
      return
    }

    this.#buildList()
    this.#observe()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  #buildList() {
    this.listTarget.replaceChildren()
    this.links = this.headings.map((heading, index) => {
      const link = document.createElement("a")
      const num = String(index + 1).padStart(2, "0")
      link.href = `#${heading.id}`
      link.textContent = `${num} · ${heading.textContent.trim()}`
      link.dataset.tocId = heading.id
      this.listTarget.append(link)
      return link
    })
  }

  #observe() {
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue
          for (const link of this.links) {
            link.classList.toggle("active", link.dataset.tocId === entry.target.id)
          }
        }
      },
      { rootMargin: "-10% 0px -75% 0px" }
    )
    this.headings.forEach((heading) => this.observer.observe(heading))
  }
}
